module.exports = __webpack_public_path__ + "static/social-candia-117b21121b23549b63b56443fd5b5f43.mp4";